export default __webpack_public_path__ + "static/media/brand_people.984050f7.png";